import { RegionData } from '@/editor/data/region/Region';
import { globalStores } from '..';
import { Curve2dUtils } from '@/editor/math/Curve2dUtils';
import { IColumnData } from '@/editor/data/model/model';
import { getPathFromEdges } from '@/editor/utils/edge';
import { dispersePath } from '@/editor/utils/shape';

export function getBelongRegionColumns(regionDatas: RegionData[]) {
  const relateColumnDatas: IColumnData[] = [];

  const columnDatas = globalStores.structStore.getColumnDatas();
  for (const columnData of columnDatas) {
    for (const regionData of regionDatas) {
      const path = dispersePath(getPathFromEdges(regionData.pathInfos)); //regionData.pathInfos.map((info) => info.start);
      const holes = regionData.holeInfos.map((holes) => dispersePath(getPathFromEdges(holes))); //regionData.holeInfos.map((holes) => holes.map((hole) => hole.start));
      if (Curve2dUtils.isPointInPolygon(columnData.center, path)) {
        let inHole = false;

        for (const hole of holes) {
          if (Curve2dUtils.isPointInPolygon(columnData.center, hole)) {
            inHole = true;
            break;
          }
        }

        if (!inHole) {
          relateColumnDatas.push(columnData);
          break;
        }
      }
    }
  }

  return relateColumnDatas;
}
